export default __webpack_public_path__ + "static/media/integration.834752fc.svg";